import React, { useState } from 'react';
import { Button } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import i18n from 'i18n-js';

import { EditorTable, useTableMapWizard } from '../context';
import { lastEditedTableId } from '../tableEdit';

function geometryKey(t: EditorTable): string {
    return [t.id, t.shape, t.x, t.y, t.width, t.height, t.rotation].join('|');
}

interface TableOverlapNoticeProps {
    /** The tables as drawn, i.e. with a pending step-5 edit already merged in. */
    tables: EditorTable[];
    overlappingIds: Set<string>;
}

export default function TableOverlapNotice({ tables, overlappingIds }: TableOverlapNoticeProps) {
    const { draft, dispatch } = useTableMapWizard();
    const [keptKeys, setKeptKeys] = useState<string[]>([]);
    const { past } = draft.tableHistory;
    const editedId =
        draft.pendingTable?.id ?? lastEditedTableId(past[past.length - 1], draft.tables);
    const table = tables.find((t) => t.id === editedId);
    if (!table || !overlappingIds.has(table.id) || keptKeys.includes(geometryKey(table))) {
        return null;
    }

    function handleMoveBack() {
        if (draft.pendingTable) dispatch({ type: 'DISCARD_PENDING_TABLE' });
        else dispatch({ type: 'UNDO_TABLE_EDIT' });
    }

    return (
        <Alert
            severity="warning"
            action={
                <>
                    <Button
                        size="small"
                        color="inherit"
                        onClick={() => setKeptKeys((keys) => [...keys, geometryKey(table)])}
                    >
                        {i18n.t('tableMaps.wizard.tables.keepIt')}
                    </Button>
                    <Button size="small" color="inherit" onClick={handleMoveBack}>
                        {i18n.t('tableMaps.wizard.tables.moveBack')}
                    </Button>
                </>
            }
        >
            {i18n.t('tableMaps.wizard.tables.overlap')}
        </Alert>
    );
}
